export default __webpack_public_path__ + "static/media/Architecture_HeroBanner.c4fa2f81.png";